import {
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  useQuery,
  useMutation,
} from 'react-query';
import { MerchantClient } from '../clients/merchants';
import { CatalogMerchantsListMerchantsOrderByEnum, Merchant } from '../openapi';

type MerchantParams = {
  merchantId?: string;
  orderBy?: CatalogMerchantsListMerchantsOrderByEnum;
  limit?: number;
};

export const useMerchantByIdQuery = (
  params: MerchantParams,
  options?: UseQueryOptions<Merchant>
): UseQueryResult<Merchant> =>
  useQuery({
    queryKey: ['merchant', params.merchantId],
    queryFn: () =>
      (params.merchantId &&
        MerchantClient.catalogMerchantsMerchantIdGetMerchant(
          params.merchantId
        ).then(({ data }) => data)) ||
      ({} as Merchant),
    ...options,
  });

export const useCreateMerchant = (
  options?: UseMutationOptions<Merchant, unknown, Merchant>
) =>
  useMutation({
    mutationFn: (newMerchant) =>
      MerchantClient.catalogMerchantsCreateMerchant(newMerchant).then(
        ({ data }) => data
      ),
    ...options,
  });
